import { fetchDestinationLogic } from './fetchDestinationLogic';
import { fetchMerchandiseLogic } from './fetchMerchandiseLogic';

export const logic = [fetchDestinationLogic, fetchMerchandiseLogic];
